import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';

import { ToastModule } from '@libs/src/toast/toast.module';
import { TrackClickModule } from '@libs/src/track-click/track-click.module';
import { TtcMatInputModule } from '@libs/src/ttc-mat-input/ttc-mat-input.module';

import { AccountConversationsBackend } from '@libs/src/account/account-conversations.backend';
import { ProfileMessageDialogService } from '@main-client/src/app/profile/profile-message-dialog/profile-message-dialog.service';

import { ProfileMessageDialogComponent } from '@main-client/src/app/profile/profile-message-dialog/profile-message-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule,
    FormsModule,
    MatButtonModule,
    MatDialogModule,
    ReactiveFormsModule,
    RouterModule,
    ToastModule,
    TrackClickModule,
    TtcMatInputModule,
  ],
  declarations: [ProfileMessageDialogComponent],
  exports: [ProfileMessageDialogComponent],
  providers: [AccountConversationsBackend, ProfileMessageDialogService],
})
export class ProfileMessageDialogModule {}
